import {ColourwayData} from "models/searchApi"
import {connect} from "react-redux"
import State from "../../models/state"
import {formatSuitTitle, formatSuitTooltipTitle} from "../../utils/colourwayBuilders"

export const mapStateToProps = (state: State) => {
    const {
        template,
        productSummary: {
            summaryData: {colourways, fit},
        },
        request: {isEnglishLang},
    } = state
    const selectedColourway = colourways.find(colourway => colourway.s) as ColourwayData
    const {t: title, id: colourwayItemNumber, p: price, sp: salePrice} = selectedColourway

    return {
        templating: template,
        title: formatSuitTitle({title, defaultTitle: title ?? "", fit, selectedColourway, isEnglishLang}),
        tooltipTitle: formatSuitTooltipTitle({
            title,
            defaultTitle: title ?? "",
            colourwayItemNumber,
            price,
            salePrice,
            fit,
            selectedColourway,
            isEnglishLang,
        }),
    }
}

export default connect(mapStateToProps)
